<template>
  <div>
    <message-panel v-if="errorMessages && errorMessages.length" mode="error" :messages="errorMessages" />
    <div v-if="serviceMember.careerProgression.hi3PastYears && serviceMember.careerProgression.hi3PastYears.length > 0" class="row">
      <div class="col-xs-12 table-wrapper">
        <div class="table-responsive">
          <table class="table table-striped table-condensed table-bordered">
            <thead>
              <tr>
                <th colspan="4" class="table-title">Hi3 Past Year Grades</th>
              </tr>
              <tr>
                <th>YOS</th>
                <th>Age</th>
                <th>Year</th>
                <th>Grade</th>
              </tr>
            </thead>
            <tbody>
              <hi3-past-year v-for="(hi3PastYear, index) in serviceMember.careerProgression.hi3PastYears"
                                   :hi3PastYear="hi3PastYear" :key="hi3PastYear.yearOfService"
                                   @change="(psy) => onHi3PYChange(psy, index)" />
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 table-wrapper">
        <div class="table-responsive">
          <table class="table table-striped table-condensed table-bordered">
            <thead>
              <tr>
                <th :colspan="hasRc ? 6 : 5" class="table-title">Career Service</th>
                <th v-if="hasRc" colspan="3" class="table-title">Retirement Points</th>
              </tr>
              <tr>
                <th>YOS</th>
                <th>Age</th>
                <th>Year</th>
                <th>Grade</th>
                <th>Override</th>
                <template v-if="hasRc">
                  <th>Active Service</th>
                  <th>Mbr</th>
                  <th>Id Paid</th>
                  <th>Id Non-Paid</th>
                </template>
              </tr>
            </thead>
            <tbody>
              <career-service-year v-for="(careerServiceYear, index) in serviceMember.careerProgression.careerService"
                                   :careerServiceYear="careerServiceYear" :key="careerServiceYear.yearOfService"
                                   @rankChange="(rank) => onRankChange(rank, index)"
                                   @activeDutyDaysChange="(days) => updateReserveComponent('activeDutyDays', days, index)"
                                   @inactiveDutyDaysPaidChange="(days) => updateReserveComponent('inactiveDutyDaysPaid', days, index)"
                                   @inactiveDutyDaysNonPaidChange="(days) => updateReserveComponent('inactiveDutyDaysNonPaid', days, index)"
                                   @onValidate="(isValid) => onValidate(isValid, index)"
                                   :hasRc="hasRc" />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import CareerProgressionTableMixin from '@/js/mixins/calculator/career-progression-table-mixin';

import Hi3PastYear from './hi3-past-year';
import CareerServiceYear from './career-service-year';

export default {
  mixins: [CareerProgressionTableMixin],

  components: {
    'hi3-past-year': Hi3PastYear,
    'career-service-year': CareerServiceYear,
  },

  methods: {
    ...mapActions([
      'updateYearOfServiceRankHi3PastYears',
      'updateOverrideRanksHi3PastYears',
    ]),

    onHi3PYChange(psy, index) {
      this.updateYearOfServiceRankHi3PastYears({ yearOfServiceRank: psy.yearOfServiceRank, index });
    },
  },
};
</script>

<style scoped lang="scss">
.table-title {
  background-color: darkgrey;
}

.table-wrapper .table {
  background-color: #fff;
}

th {
  text-align: center;
}
</style>
